import React from 'react'
import { Link } from 'react-router-dom'
import { pure } from 'recompose'
import Paper from 'material-ui/Paper'
import RaisedButton from 'material-ui/RaisedButton'
import FontIcon from 'material-ui/FontIcon'
import { Row, Col } from 'pui-react-grids'
import SwapTextualDescription from './SwapTextualDescription'
import SwapShippingInfo from './SwapShippingInfo'
import { themeColors } from '../../styles/theme'
import FlatButton from 'material-ui/FlatButton'
import { isNullOrUndef } from '../../utils'
import { AFFIDABILITA_ICON_NAME } from '../../styles/icons'
import { SWAPS_DONE_ICON_NAME } from '../../styles/icons'
import { PLACE_ICON_NAME } from '../../styles/icons'
import moment from 'moment'
import {
  isProponente,
  isDestinatario,
  isSwapValid,
  getSwapForYou,
  getSwapForMe,
  checkUserCanSwap,
  isSwapOutdated,
} from '../../utils'

const styles = {
  containerStyle: {
    marginBottom: 30,
    textAlign: 'center',
    padding: 10,
  },
  titleStyle: {
    fontSize: 18,
    fontWeight: 'bold',
  },
  text: {
    lineHeight: 1.2,
    color: themeColors.lightblack,
    marginTop: 4,
    marginBottom: 4,
  },
  button: {
    margin: 5,
  },
  messageContent: {
    fontSize: '15px',
    paddingBottom: '10px',
  },
  messageLink: {
    color: themeColors.primary,
  },
  messageIcon: {
    top: 9,
    color: themeColors.positive,
    marginRight: 5,
  },
  motivationContainer: {
    fontSize: '14px',
  },
  motivationTitle: {
    color: themeColors.energized,
    fontWeight: 'bold',
  },
  motivationText: {
    color: themeColors.energized,
    fontStyle: 'italic',
  },
  backBtn: {
    height: '25px',
    lineHeight: '25px',
  },
  userInfo: {
    padding: 10,
    textAlign: 'center',
    border: '0.5px solid #eee',
  },
  userInfoLinkStyle: {
    fontSize: 16,
    fontWeight: 'bold',
    marginTop: 0,
    marginBottom: 0,
    color: themeColors.lightblack,
    ':visited': {
      color: themeColors.lightblack,
    },
  },
  userInfoText: {
    color: themeColors.energized,
    fontSize: 11,
  },
  userInfoData: {
    display: 'inline-flex',
    padding: '2px',
  },
  userInfoIcon: {
    marginLeft: 7,
    fontSize: 18,
    poaition: 'relative',
    bottom: 2,
  },
}

const RejectMotivation = ({ motivation }) => {
  const matches = motivation.match(/to:\/swap\/(\d+)/)
  if (matches) {
    return (
      <span>
        Rifiuto per{' '}
        <Link
          style={{ color: themeColors.positive }}
          to={`/swap/${matches[1]}`}>
          controproposta
        </Link>
      </span>
    )
  } else {
    return <span>{motivation}</span>
  }
}

const SwapSummary = ({
  swap,
  user,
  editable,
  onEditClick,
  onUndoEditClick,
  performingAction,
  onAcceptClick,
  onRejectClick,
  onCancelClick,
  onFeedbackClick,
  onSwap,
  onMessageClick,
  onArchiveClick,
}) => {
  const swapForYou = getSwapForYou(swap, user)
  const swapForMe = getSwapForMe(swap, user)
  const addressComplete = checkUserCanSwap(user)

  return (
    <div>
      <Row>
        <Col md={6} />
        <Col md={12}>
          <Paper style={styles.containerStyle}>
            <FlatButton
              label="Torna ai tuoi scambi"
              icon={
                <FontIcon
                  className="material-icons"
                  style={{ fontSize: 18, position: 'relative', bottom: 1 }}>
                  {SWAPS_DONE_ICON_NAME}
                </FontIcon>
              }
              style={styles.backBtn}
              labelStyle={{ fontSize: 12 }}
              containerElement={<Link to={`/me/swaps`} />}
            />
            <div style={{ paddingTop: 10, paddingBottom: 10 }}>
              <div style={styles.text}>
                {(isNullOrUndef(swap.stato) || swap.stato === 'proposta') && (
                  <SwapTextualDescription swap={swap} user={user} />
                )}
                {swap.stato === 'accettata' && (
                  <div>
                    <div style={{ marginBottom: '10px' }}>
                      {isDestinatario(swap, user) && (
                        <div>
                          Hai accettato la proposta in data{' '}
                          {moment(swap.updated_at).format('D MMMM YYYY')}.
                        </div>
                      )}
                      {isProponente(swap, user) && (
                        <div>
                          {swap.destinatario.username} ha accettato la proposta
                          in data{' '}
                          {moment(swap.updated_at).format('D MMMM YYYY')}.
                        </div>
                      )}
                    </div>
                    <SwapShippingInfo swap={swap} user={user} />
                  </div>
                )}
                {swap.stato === 'rifiutata' && (
                  <div>
                    {isDestinatario(swap, user) && (
                      <div>
                        <div>Hai rifiutato la proposta.</div>
                        {swapForMe.esito.motivo && (
                          <p style={styles.motivationContainer}>
                            <span style={styles.motivationTitle}>
                              Motivazione:{' '}
                            </span>
                            <span style={styles.motivationText}>
                              <RejectMotivation
                                motivation={swapForMe.esito.motivo}
                              />
                            </span>
                          </p>
                        )}
                      </div>
                    )}
                    {isProponente(swap, user) && (
                      <div>
                        {swap.destinatario.username} ha rifiutatato la proposta.
                        {swapForYou.esito.motivo && (
                          <p style={styles.motivationContainer}>
                            <span style={styles.motivationTitle}>
                              Motivazione:{' '}
                            </span>
                            <span style={styles.motivationText}>
                              <RejectMotivation
                                motivation={swapForYou.esito.motivo}
                              />
                            </span>
                          </p>
                        )}
                      </div>
                    )}
                  </div>
                )}
                {swap.stato === 'annullata' && (
                  <div>
                    {isProponente(swap, user) && (
                      <div>Hai annullato la proposta.</div>
                    )}
                    {isDestinatario(swap, user) && (
                      <div>
                        {swap.destinatario.username} ha annullato la proposta.
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
            {editable && (
              <div style={{ paddingBottom: 10 }}>
                <RaisedButton
                  disabled={performingAction || !isSwapValid(swap)}
                  onClick={onSwap}
                  label="Proponi"
                  style={styles.button}
                  primary={true}
                />
                {!isNullOrUndef(swap.stato) && (
                  <RaisedButton
                    disabled={performingAction}
                    onClick={onUndoEditClick}
                    label="Annulla Modifiche"
                    style={styles.button}
                    backgroundColor={themeColors.lightblack}
                    labelColor={themeColors.white}
                  />
                )}
              </div>
            )}

            {addressComplete ? null : (
              <p>
                <span style={{ color: themeColors.secondary }}>ATTENZIONE</span>
                : il tuo indirizzo è incompleto,{' '}
                <Link
                  style={{ color: themeColors.positive }}
                  to={{
                    pathname: '/profile/edit',
                    state: { redirectToSwap: `/swap/${swap.id}` },
                  }}>
                  clicca qui
                </Link>{' '}
                per completare i tuoi dati personali ed effettuare scambi
              </p>
            )}

            {swap.stato === 'proposta' &&
              isDestinatario(swap, user) && (
                <div style={{ paddingBottom: 10 }}>
                  <RaisedButton
                    disabled={performingAction || !addressComplete}
                    onClick={onAcceptClick}
                    label="Accetta"
                    style={styles.button}
                    primary={true}
                  />
                  <RaisedButton
                    disabled={performingAction || !addressComplete}
                    label="Rifiuta"
                    onClick={onRejectClick}
                    style={styles.button}
                    backgroundColor={themeColors.lightblack}
                    labelColor={themeColors.white}
                  />
                  <RaisedButton
                    disabled={performingAction || !addressComplete}
                    onClick={onEditClick}
                    label="Modifica"
                    style={styles.button}
                    backgroundColor={themeColors.lightblack}
                    labelColor={themeColors.white}
                  />
                </div>
              )}

            {swap.stato === 'proposta' &&
              isProponente(swap, user) &&
              !editable && (
                <div style={{ paddingBottom: 10 }}>
                  <RaisedButton
                    onClick={onCancelClick}
                    disabled={performingAction}
                    label="Annulla"
                    style={styles.button}
                    primary={true}
                  />
                  <RaisedButton
                    disabled={performingAction}
                    onClick={onEditClick}
                    label="Modifica"
                    style={styles.button}
                    backgroundColor={themeColors.lightblack}
                    labelColor={themeColors.white}
                  />
                </div>
              )}

            <div style={styles.userInfo}>
              <Link
                style={styles.userInfoLinkStyle}
                to={`/user/${swapForYou.user.username}`}>
                {swapForYou.user.username}{' '}
                {swap.stato === 'accettata' && (
                  <span>({swapForYou.user.nome})</span>
                )}
              </Link>
              <div style={{ marginTop: '8px' }}>
                <div style={styles.userInfoData}>
                  <FontIcon
                    className="material-icons"
                    style={styles.userInfoIcon}>
                    {PLACE_ICON_NAME}
                  </FontIcon>
                  <span style={styles.userInfoText}>
                    {swapForYou.user.district}
                  </span>
                </div>
                <div style={styles.userInfoData}>
                  <FontIcon
                    className="material-icons"
                    style={styles.userInfoIcon}>
                    {SWAPS_DONE_ICON_NAME}
                  </FontIcon>
                  <span style={styles.userInfoText}>
                    {swapForYou.user.transazioni}
                  </span>
                </div>
                <div style={styles.userInfoData}>
                  <FontIcon
                    className="material-icons"
                    style={styles.userInfoIcon}>
                    {AFFIDABILITA_ICON_NAME}
                  </FontIcon>
                  <span style={styles.userInfoText}>
                    {swapForYou.user.transazioni > 3
                      ? `${Number(
                          swapForYou.user.affidabilita * 100
                        ).toFixed()}%`
                      : '-'}
                  </span>
                </div>
              </div>
              {(swap.stato === 'accettata' || swap.stato === 'proposta') && (
                <FlatButton
                  label="Invia messaggio"
                  primary={true}
                  onClick={onMessageClick}
                  icon={<FontIcon className="material-icons">message</FontIcon>}
                />
              )}
            </div>
          </Paper>
        </Col>
        <Col md={6} />
      </Row>
      {/* Feedback card */}
      {swap.stato === 'accettata' &&
        +swapForYou.esito.feedback === 0 &&
        swapForMe.esito.stato !== 'archiviata' && (
          <Row>
            <Col md={6} />
            <Col md={12}>
              <Paper style={styles.containerStyle}>
                <div style={{ paddingBottom: 5, paddingTop: 5 }}>
                  {!isSwapOutdated(swap) && (
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                      }}>
                      <RaisedButton
                        disabled={performingAction}
                        onClick={onFeedbackClick}
                        label="Lascia Feedback"
                        style={styles.button}
                        primary={true}
                      />
                      <span>
                        Il feedback va rilasciato entro massimo tre mesi
                      </span>
                    </div>
                  )}
                  {isSwapOutdated(swap) && (
                    <RaisedButton
                      disabled={performingAction}
                      label="Archivia"
                      onClick={onArchiveClick}
                      style={styles.button}
                      backgroundColor={themeColors.lightblack}
                      labelColor={themeColors.white}
                    />
                  )}
                </div>
              </Paper>
            </Col>
            <Col md={6} />
          </Row>
        )}
    </div>
  )
}

export default pure(SwapSummary)



// WEBPACK FOOTER //
// ./src/common/Swap/SwapSummary.js